import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ClientDocuments from "@/components/ClientDocuments";
import PersonalVault from "@/components/PersonalVault";
import PersonalExpenses from "@/components/PersonalExpenses";

export default function PersonalSpace() {
  return (
    <div className="space-y-5 fade-in">
      <div>
        <h1 className="font-head text-3xl font-semibold tracking-tight">Kişisel Alanım</h1>
        <p className="text-sm text-muted-foreground mt-1">Kendi evraklarınız, şifreleriniz ve giderleriniz — mükellef kayıtlarından bağımsız, size özel</p>
      </div>

      <Tabs defaultValue="evraklar">
        <TabsList>
          <TabsTrigger value="evraklar" data-testid="tab-personal-evraklar">Evraklarım</TabsTrigger>
          <TabsTrigger value="sifreler" data-testid="tab-personal-sifreler">Şifrelerim</TabsTrigger>
          <TabsTrigger value="giderler" data-testid="tab-personal-giderler">Giderlerim</TabsTrigger>
        </TabsList>

        <TabsContent value="evraklar">
          <ClientDocuments personal />
        </TabsContent>

        <TabsContent value="sifreler">
          <PersonalVault />
        </TabsContent>

        <TabsContent value="giderler">
          <PersonalExpenses />
        </TabsContent>
      </Tabs>
    </div>
  );
}
